import React from 'react'

import { BrowserRouter, Route, Routes } from 'react-router-dom'

import App from '../App'
import NotFountPage from '../views/NotFountPage'
import Rutas from '../views/Rutas'

type Props = {}

const Routing = (props: Props) => {

    const routes = (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/rutas" element={<Rutas />} />
            <Route path="*" element={<NotFountPage />} />
        </Routes>
    </BrowserRouter>
    )

    return routes;
  
}

export default Routing